import React from "react";
import { NavLink } from "react-router-dom";
import { IconArrowRightThin } from "../../assets/svgExport";

type GetInTouchProps = {
  text?: {
    heading?: React.ReactNode;
    paragraph?: React.ReactNode;
  };
};

export default function GetInTouch(props: GetInTouchProps) {
  const heading = props.text?.heading ?? (
    <>
      Simplify your offshore transport
      <br />
      from start to finish
    </>
  );
  const paragraph =
    props.text?.paragraph ??
    "Contact our team to discuss how Venti Maris can deliver your project components safely, efficiently and on budget.";

  return (
    <div className="text-center  border-t pt-20">
      <h2>{heading}</h2>
      <p className="max-w-[70%] mx-auto">{paragraph}</p>
      <NavLink
        className="inline-flex items-center gap-1 mt-10 bg-main-dark text-lg border border-white px-8 py-3 hover:border-main-dark text-white"
        to="/contact"
      >
        Get in touch
        <IconArrowRightThin className="w-10" />
      </NavLink>
    </div>
  );
}
